export const FEATURE_FLAGS = {
  // Set to true to show the Interior Design service card and enable the full ID flow.
  // Set to false to hide it from users without removing any code.
  INTERIOR_DESIGN_ENABLED: false,
};
